import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let PageListPaginator = class PageListPaginator extends Vue {
    get hasPreviousPage() {
        return !!this.pagination.previous;
    }
    get hasNextPage() {
        return !!this.pagination.next;
    }
    getToNextPage() {
        this.$emit('nextPage');
    }
    getToPreviousPage() {
        this.$emit('previousPage');
    }
};
__decorate([
    Prop({ type: Object, required: true })
], PageListPaginator.prototype, "pagination", void 0);
__decorate([
    Prop({ type: String, default: 'paginator-next' })
], PageListPaginator.prototype, "dataCyNext", void 0);
__decorate([
    Prop({ type: String, default: 'paginator-back' })
], PageListPaginator.prototype, "dataCyBack", void 0);
PageListPaginator = __decorate([
    Component
], PageListPaginator);
export default PageListPaginator;
